import { useRef, useState } from "react";

/**
 * Factor changes need a recent sign-in. When the server asks for one, the action
 * is parked here, the view shows its re-authentication dialog, and the action
 * runs again once the user has confirmed it's them.
 */
export function useReauthGate() {
    const [reauthenticating, setReauthenticating] = useState(false);
    const retryAction = useRef<() => void>();

    return {
        reauthenticating,
        /** Parks `retry` and opens the dialog */
        require: (retry: () => void) => {
            retryAction.current = retry;
            setReauthenticating(true);
        },
        cancel: () => {
            retryAction.current = undefined;
            setReauthenticating(false);
        },
        succeed: () => {
            setReauthenticating(false);
            const retry = retryAction.current;
            retryAction.current = undefined;
            retry?.();
        },
    };
}

export type ReauthGate = ReturnType<typeof useReauthGate>;
